<mat-card class="slidecontent">
  <div class="headcontent">
    <div class="pophead">
      <h3>Edit User</h3>

      <mat-icon (click)="close(closePannel)" class="close">close</mat-icon>

    </div>
  </div>

  <div class="dialog_content">

    <form [formGroup]="updateUserDetailform">

      <div fxLayout="row" fxLayoutAlign="start start">
        <mat-form-field appearance="legacy" class="form-element" fxFlex>
          <mat-label>First Name</mat-label>
          <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
          <input matInput maxlength="50" placeholder="First Name" formControlName="firstname" [(ngModel)]="updateUserDetail.FirstName"
            (keyup)="checkregex()">
          <mat-error>
            {{ titleAlert }}
          </mat-error>
        </mat-form-field>
      </div>

      <div fxLayout="row" fxLayoutAlign="start start">

        <mat-form-field appearance="legacy" class="form-element" fxFlex>
          <mat-label>Last Name</mat-label>
          <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
          <input matInput maxlength="50" placeholder="Last Name" formControlName="lastname" [(ngModel)]="updateUserDetail.LastName"
            (keyup)="checkregex()">
          <mat-error>
            {{ titleAlert }}
          </mat-error>
        </mat-form-field>
      </div>

      <div fxLayout="row" fxLayoutAlign="start start">
        <mat-form-field appearance="legacy" fxFlex>
          <mat-label>Phone</mat-label>
          <span matPrefix>+1 &nbsp;</span>
          <mat-icon matSuffix class="secondary-text">phone</mat-icon>
          <input matInput placeholder="Phone" formControlName="phoneNumber" [(ngModel)]="updateUserDetail.PhoneNumber"
            mask="(000) 000-0000">
          <mat-error>{{getPhoneErrorMessage()}}</mat-error>
        </mat-form-field>

      </div>
      <!-- <div fxLayout="row" fxLayoutAlign="start start">
                    <mat-form-field class="form-element" fxFlex>
                        <span matPrefix>+1 &nbsp;</span>
                        <input matInput placeholder="Phone" formControlName="phoneNumber"
                            [(ngModel)]="updateUserDetail.PhoneNumber" mask="(000) 000-0000">
                        <mat-error>{{getPhoneErrorMessage()}}</mat-error>
                    </mat-form-field>
                </div> -->

                
        <div  class="selectedPermission" *ngIf="selectedOfficeArray.length > 0" >
          <h4 _ngcontent-rnx-c336="">Selected Office</h4>
          <div class="selList">
              <span *ngFor="let o of selectedOfficeArray">
                  <h4>{{o.officeName}}</h4>
                  <button mat-icon-button><mat-icon (click)="removeSelectedOffice(o)">cancel</mat-icon></button>
              </span>
          </div>
      </div>
      
      <div fxLayout="row" fxLayoutAlign="start start">
        
        <mat-form-field appearance="" class="mt-10 mb-10" style="position: relative;">
          <mat-label>Search Office</mat-label>
          <input matInput placeholder="Type & Select" aria-label="State" [matAutocomplete]="auto"
            (input)="searchOfficeFun($event.target.value)" [formControl]="officectrl" id="officectrlId">
          <mat-autocomplete #auto="matAutocomplete">
            <mat-option (keydown.enter)="selectedOffice(office)" (click)="selectedOffice(office)"
              *ngFor="let office of searchOffice" [value]="office.officeName">
              <span class="userlist" fxLayout="row" fxLayoutAlign="flex-start center">
               
                <div class="info">
                  <p> {{ office.officeName }}</p>                
                </div>
              </span>
            </mat-option>
          </mat-autocomplete>

        </mat-form-field>
        
      </div>

      <div class="selectedPermission mb-5">
        <h4>Select Roles </h4>
        <ng-multiselect-dropdown
        [placeholder]="'Search or Select'"
        [settings]="dropdownSettings"
        [data]="dropdownList"
        [(ngModel)]="selectedItems"
        formControlName="userRoles"                
        name="userRoles">
        </ng-multiselect-dropdown>

        <!-- <mat-list-item class="primary-imenu-item fullw" role="listitem">
          <mat-form-field appearance="legacy" class="select-form form-element" fxFlex>
            <mat-select placeholder="Roles" name="role" class="filter-select" formControlName="userRoles"
              [(ngModel)]="updateUserDetail.UserRoles" [compareWith]="equals" multiple>
              <mat-option *ngFor="let role of roles" [value]="role.roleName">
                {{role.roleName}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </mat-list-item> -->
      </div>

      <div class="form-element">
        <mat-checkbox formControlName="isActive" color="primary" [(ngModel)]="updateUserDetail.isActive">Active
        </mat-checkbox>
      </div>
    </form>
  </div>


  <div class="actionBtn">

    <button mat-flat-button class="cancel" (click)="close(closePannel)">Cancel</button>
    <button mat-flat-button class="calltoaction" type="submit" 
    [disabled]="updateUserDetailform.invalid || !updateUserDetailform.dirty"   
      (click)="updateUser()" color="primary">Update
      <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
      </mat-spinner></mat-icon>
    </button>
  </div>


</mat-card>
<div class="overlay" (click)="close(closePannel)"></div>